import React from "react";

import { faPaperclip } from "@fortawesome/pro-solid-svg-icons/faPaperclip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Email from "@mapmycustomers/shared/types/email/Email";

import styles from "./EmailAttachmentsIcon.module.scss";

interface EmailAttachmentsIconProps {
  email: Email;
}

const EmailAttachmentsIcon: React.FC<EmailAttachmentsIconProps> = ({ email }) => {
  if (!email.attachments?.length) {
    return null;
  }

  return <FontAwesomeIcon className={styles.icon} icon={faPaperclip} size="lg" />;
};

export default EmailAttachmentsIcon;
